import { TextFieldProps } from '@mui/material';
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers-pro';
import { addHours, startOfToday } from 'date-fns';
import { forwardRef } from 'react';
import { FieldError } from 'react-hook-form';

import { commonInputProps } from '../../DemandDetailForm.common';
import { useFormFieldErrorTranslation } from '~/hooks';

// set a reference date to noon so that the time is defaulted to 12:00 when selecting a date
const referenceDate = addHours(startOfToday(), 12);

export interface DeadlineInputProps extends DateTimePickerProps<Date> {
  error?: FieldError | undefined;
  onBlur?: TextFieldProps['onBlur'];
}

export const DeadlineInput = forwardRef<HTMLDivElement, DeadlineInputProps>(function DeadlineInput(
  { error, onBlur, ...props },
  ref,
) {
  const { errorToHelperText } = useFormFieldErrorTranslation();

  return (
    <DateTimePicker
      {...props}
      ref={ref}
      referenceDate={referenceDate}
      disablePast
      displayWeekNumber
      slotProps={{
        actionBar: { actions: ['today', 'clear', 'accept'] },
        openPickerButton: { tabIndex: -1 },
        textField: {
          InputLabelProps: { shrink: true },
          error: !!error,
          onBlur,
          helperText: errorToHelperText(error),
          ...commonInputProps,
        },
      }}
    />
  );
});
